export default __webpack_public_path__ + "static/media/newfogg.c53efe7d.jpeg";